import type { ReactNode } from 'react';
import styles from './style.module.css';

type Variant = 'admin' | 'client' | 'active' | 'inactive';

type Props = {
  variant: Variant;
  children: ReactNode;
  className?: string;
};

export function Badge({ variant, children, className }: Props) {
  return <span className={`${styles.badge} ${styles[variant]}${className ? ` ${className}` : ''}`}>{children}</span>;
}
